$ = global.$ = global.jQuery = window.$ = window.jQuery = require('jquery');

global.bootstrap = window.bootstrap = require('bootstrap');

require('select2');
import { Fancybox } from "@fancyapps/ui";
require('../../../Framework/assets/js/cms-form-conditions')
require('../../../Framework/assets/js/cms-ajax-form')
require('../../../Modules/Media/assets/media')
// require('../../../Modules/Captcha/assets/js/cms-captcha')
require('../../../Framework/assets/js/cms-select2')
require('../../../Framework/assets/js/cms-datepicker')

window.fancybox = Fancybox;


$('.eshop-cart-summary').on('click', '.eshop-submit', function (e) {
    e.preventDefault();
    $('#cart-checkout-form').submit();
});

if ($('.modal-ajax-form').length > 0) {
    var myModalEl = document.querySelector('.modal-ajax-form')
    let bsModal = new global.bootstrap.Modal(myModalEl, {});
    bsModal.show();
}

setTimeout(function (){
    $('form[data-auto-submitable]').submit();
}, 1000);

var jBody = $('body');
jBody.on('click', 'a[data-confirm],button[data-confirm]', function (e) {//a confirm
    var r = confirm($(this).data("confirm"));
    if (r !== true) {
        e.preventDefault();
    } else {
        $(this).trigger('click-confirmed', e);
    }
});

$(document).on('click', '.reload-page', function() {
    location.reload();
});